import React from 'react'

const SvgSunrise = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M11 5a1 1 0 112 0v3.083a6.04 6.04 0 00-2 0V5zM8.524 9.11L6.12 6.706a1 1 0 10-1.414 1.414l2.402 2.402A6.034 6.034 0 018.524 9.11zM3 13h3.083a6.04 6.04 0 000 2H3a1 1 0 110-2zM8 14c0 .345.044.68.126 1h7.748A4 4 0 108 14zM21 15h-3.083a6.036 6.036 0 000-2H21a1 1 0 110 2zM16.99 10.667l2.545-2.546a1 1 0 10-1.414-1.414l-2.505 2.505c.535.404 1 .896 1.374 1.455zM3 17a1 1 0 100 2h18a1 1 0 100-2H3z' />
  </svg>
)

export default SvgSunrise
